import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const DISMISS_KEY = "ll_cookie_banner_dismissed";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!localStorage.getItem(DISMISS_KEY)) {
      // small delay so it doesn't fight the page entrance animation
      const t = setTimeout(() => setVisible(true), 400);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* private mode */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-40 animate-fade-up"
    >
      <div className="grain-panel border border-border bg-card/95 backdrop-blur-md rounded-2xl p-5 shadow-2xl">
        <div className="flex items-start gap-3">
          <div className="flex-1 min-w-0">
            <p className="font-display text-lg tracking-tight text-foreground">One tiny cookie</p>
            <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">
              We only use one essential sign-in cookie —{" "}
              <span className="font-mono text-xs bg-secondary px-1.5 py-0.5 rounded">ll_token</span>.
              No tracking, no ads. Details in our{" "}
              <Link to="/privacy" className="underline hover:text-foreground" data-testid="cookie-banner-privacy-link">
                Privacy Policy
              </Link>.
            </p>
            <button
              onClick={dismiss}
              className="mt-4 inline-flex items-center rounded-full bg-primary text-primary-foreground px-4 h-9 text-sm font-medium hover:glow-amber-sm transition-shadow"
              data-testid="cookie-banner-dismiss-btn"
            >
              Got it
            </button>
          </div>
          <button
            onClick={dismiss}
            aria-label="Dismiss cookie notice"
            className="text-muted-foreground hover:text-foreground shrink-0"
            data-testid="cookie-banner-close-btn"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
